var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":[
      { text: 'Anzahl', value: 'orderedQuantity' },
      {
        text: 'Name',
        align: 'start',
        value: 'name',
        width: '25%'
      },
      {
        text: 'Beschreibung',
        value: 'description',
        width: '33%'
      },
      {
        text: _vm.isOneTimeProduct === true ? 'Einmaliger Preis' : 'Preis',
        value: 'price',
        width: '10%'
      },
      { text: 'Gültig ab', value: 'validFrom', width: '10%' },
      { text: 'Gültig bis', value: 'validUntil', width: '10%' }
    ],"items":_vm.availableProductsWithOrderedQuantities,"single-select":_vm.singleSelect,"item-key":"id","disabled":_vm.disabled,"dense":"","options":{ itemsPerPage: -1 },"hide-default-footer":"","show-select":""},on:{"input":function($event){return _vm.emitCurrentState()}},scopedSlots:_vm._u([{key:"header.data-table-select",fn:function(ref){return undefined}},{key:"item.data-table-select",fn:function(ref){
    var item = ref.item;
    var isSelected = ref.isSelected;
    var select = ref.select;
return [_c('v-simple-checkbox',{attrs:{"value":isSelected,"disabled":_vm.disabled},on:{"input":function($event){return select($event)}}})]}},{key:"item.orderedQuantity",fn:function(ref){
    var item = ref.item;
return [(_vm.itemIsSelected(item))?_c('div',{staticClass:"v-select allign-selection"},[_c('v-select',{attrs:{"items":_vm.buildQuantitySelection(item),"dense":"","hide-details":"","type":"number"},on:{"change":function($event){return _vm.emitCurrentState()}},model:{value:(item.orderedQuantity),callback:function ($$v) {_vm.$set(item, "orderedQuantity", $$v)},expression:"item.orderedQuantity"}})],1):_vm._e()]}},{key:"item.description",fn:function(ref){
    var item = ref.item;
return [(item.description)?_c('div',[_vm._v(" "+_vm._s(item.description)+" ")]):_c('div',[_vm._v(" - ")])]}},{key:"item.price",fn:function(ref){
    var item = ref.item;
return [(item.price)?_c('div',[_vm._v(" "+_vm._s(item.price)+" € ")]):_c('div',[_vm._v(" - ")])]}},{key:"item.validFrom",fn:function(ref){
    var item = ref.item;
return [(item.validFrom)?_c('div',[_vm._v(" "+_vm._s(_vm.formatLocalDate(item.validFrom))+" ")]):_c('div',[_vm._v(" - ")])]}},{key:"item.validUntil",fn:function(ref){
    var item = ref.item;
return [(item.validUntil)?_c('div',[_vm._v(" "+_vm._s(_vm.formatLocalDate(item.validUntil))+" ")]):_c('div',[_vm._v(" - ")])]}}]),model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}},[_c('template',{slot:"no-data"},[_vm._v(" Es existieren keine Produkte von diesem Dokumententyp. ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }